import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/TradingModule/TradingModule.tsx");
